import styled from 'styled-components';

const getStatusColors = (status) => {
  switch (status) {
    case 'open':
      return {
        background: '#EAF7EE',
        color: '#167532',
      };
    case 'created':
      return {
        background: '#FEF5E7',
        color: '#F39C12',
      };
    case 'closed':
    case 'close':
      return {
        background: '#FAE8E9',
        color: '#94090F',
      };
    default:
      return {
        background: '#F5F5F5',
        color: '#828282',
      };
  }
};

export const BadgeContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 100px;
  background-color: ${({ status }) => getStatusColors(status).background};
  outline: 1px solid ${({ status }) => getStatusColors(status).color};
  height: 100%;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    fill: ${({ status }) => getStatusColors(status).color};
  }
`;

export const Label = styled.div`
  color: ${({ status }) => getStatusColors(status).color};
  font-size: 11px;
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: center;
  word-wrap: break-word;
`;
